<template>
	<div class="email-configs">
		<el-card>
			<div slot="header" style="display: flex; justify-content: space-between; align-items: center;">
				<span>邮箱配置管理</span>
				<el-button type="primary" @click="showAddDialog" icon="el-icon-plus">
					添加配置
				</el-button>
			</div>
			
			<el-table :data="configs" v-loading="loading" style="width: 100%">
				<el-table-column prop="email" label="邮箱地址" width="200"></el-table-column>
				<el-table-column prop="provider" label="提供商" width="120">
					<template slot-scope="scope">
						<el-tag :type="getProviderType(scope.row.provider)">
							{{ getProviderName(scope.row.provider) }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="isActive" label="状态" width="100">
					<template slot-scope="scope">
						<el-tag :type="scope.row.isActive ? 'success' : 'danger'">
							{{ scope.row.isActive ? '激活' : '禁用' }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="createdAt" label="创建时间" width="180">
					<template slot-scope="scope">
						{{ formatDate(scope.row.createdAt) }}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="300">
					<template slot-scope="scope">
						<el-button size="mini" @click="editConfig(scope.row)">编辑</el-button>
						<el-button size="mini" type="danger" @click="deleteConfig(scope.row)">删除</el-button>
						<el-button v-if="scope.row.provider==='outlook'" size="mini" type="primary" @click="openOAuth(scope.row)">授权Outlook</el-button>
						<el-button v-if="scope.row.provider==='outlook'" size="mini" @click="checkHealth(scope.row)">健康检查</el-button>
						<el-button v-if="scope.row.provider==='outlook'" size="mini" @click="refreshToken(scope.row)">刷新令牌</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-card>
		
		<!-- 添加/编辑对话框 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px">
			<el-form :model="form" :rules="rules" ref="form" label-width="120px">
				<el-form-item label="邮箱地址" prop="email">
					<el-input v-model="form.email" placeholder="请输入邮箱地址"></el-input>
				</el-form-item>
				
				<el-form-item label="邮箱提供商" prop="provider">
					<el-select v-model="form.provider" placeholder="请选择提供商" style="width: 100%" @change="onProviderChange">
						<el-option label="Gmail" value="gmail"></el-option>
						<el-option label="QQ邮箱" value="qq"></el-option>
						<el-option label="网易163" value="netease_163"></el-option>
						<el-option label="Outlook" value="outlook"></el-option>
						<el-option label="网易126" value="netease_126"></el-option>
						<el-option label="Yahoo邮箱" value="yahoo"></el-option>
						<el-option label="新浪邮箱" value="sina"></el-option>
					</el-select>
				</el-form-item>
				
				<template v-if="form.provider !== 'outlook'">
					<el-form-item label="授权码" prop="authCode">
						<el-input v-model="form.authCode" type="password" placeholder="请输入授权码"></el-input>
					</el-form-item>
				</template>
				<template v-else>
					<el-form-item label="Outlook Client ID" prop="oauthClientId">
						<el-input v-model="form.oauthClientId" placeholder="请输入Azure应用的Client ID"></el-input>
					</el-form-item>
					<el-form-item label="Tenant ID" prop="oauthTenantId">
						<el-input v-model="form.oauthTenantId" placeholder="common 或具体租户ID"></el-input>
					</el-form-item>
					<el-form-item label="Redirect URI">
						<el-input v-model="form.oauthRedirectUri" placeholder="可选"></el-input>
					</el-form-item>
					<el-form-item label="Client Secret">
						<el-input v-model="form.oauthClientSecret" type="password" placeholder="如为公共客户端可留空"></el-input>
					</el-form-item>
				</template>
				
				<el-form-item label="状态">
					<el-switch v-model="form.isActive" active-text="激活" inactive-text="禁用"></el-switch>
				</el-form-item>
				
				<el-form-item>
					<el-button type="info" @click="testConnection" :loading="testing">
						{{ testing ? '测试中...' : '测试连接' }}
					</el-button>
					<el-button v-if="form.provider==='outlook' && isEdit" type="primary" @click="openOAuth(form)" :loading="authorizing" style="margin-left: 10px;">
						授权Outlook
					</el-button>
				</el-form-item>
			</el-form>
			
			<div slot="footer">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" @click="saveConfig" :loading="saving">保存</el-button>
			</div>
		</el-dialog>

		<!-- Outlook 设备码授权对话框 -->
		<el-dialog title="Outlook 设备码授权" :visible.sync="oauthDialogVisible" width="520px">
			<div v-if="oauthInfo">
				<p>请在浏览器打开以下链接并输入设备码完成授权：</p>
				<p>
					<b>Verification URL：</b>
					<a :href="oauthInfo.verification_uri || oauthInfo.verification_uri_complete" target="_blank">{{ oauthInfo.verification_uri || oauthInfo.verification_uri_complete }}</a>
				</p>
				<p><b>User Code：</b> <el-tag type="success">{{ oauthInfo.user_code }}</el-tag></p>
				<p v-if="oauthInfo.message">{{ oauthInfo.message }}</p>
			</div>
			<div slot="footer">
				<el-button @click="oauthDialogVisible = false">关闭</el-button>
				<el-button type="primary" :loading="authorizing" @click="confirmAuthorized">我已完成授权</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'EmailConfigs',
	data() {
		return {
			configs: [],
			loading: false,
			dialogVisible: false,
			saving: false,
			testing: false,
			isEdit: false,
			form: {
				email: '',
				provider: '',
				authCode: '',
				isActive: true,
				oauthClientId: '',
				oauthTenantId: '',
				oauthRedirectUri: '',
				oauthClientSecret: ''
			},
			rules: {
				email: [
					{ required: true, message: '请输入邮箱地址', trigger: 'blur' },
					{ type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
				],
				provider: [
					{ required: true, message: '请选择邮箱提供商', trigger: 'change' }
				],
				authCode: [
					{ required: true, message: '请输入授权码', trigger: 'blur', validator: (rule, value, callback) => {
						if (this.form.provider === 'outlook') { callback(); } else { if (!value) callback(new Error('请输入授权码')); else callback(); }
					} }
				],
				oauthClientId: [
					{ required: true, message: '请输入Client ID', trigger: 'blur', validator: (rule, value, callback) => {
						if (this.form.provider !== 'outlook') return callback();
						if (!value) return callback(new Error('请输入Client ID'));
						callback();
					} }
				]
			},
			oauthDialogVisible: false,
			oauthInfo: null,
			authorizing: false,
			selectedOAuthConfigId: null
		}
	},
	computed: {
		dialogTitle() {
			return this.isEdit ? '编辑邮箱配置' : '添加邮箱配置';
		},
		currentUserId() {
			return this.$store.state.user ? this.$store.state.user.id : null;
		}
	},
	mounted() {
		this.loadConfigs();
	},
	methods: {
		async loadConfigs() {
			if (!this.currentUserId) {
				this.$message.error('用户未登录');
				return;
			}
			this.loading = true;
			try {
				const response = await this.$http.get('/api/email-configs', {
					params: { userId: this.currentUserId }
				});
				this.configs = response.data;
			} catch (error) {
				console.error('加载邮箱配置失败:', error);
				this.$message.error('加载邮箱配置失败');
			} finally {
				this.loading = false;
			}
		},
		onProviderChange() {
			// 清空与另一种模式相关的字段
			if (this.form.provider === 'outlook') {
				this.form.authCode = '';
			} else {
				this.form.oauthClientId = '';
				this.form.oauthTenantId = '';
				this.form.oauthRedirectUri = '';
				this.form.oauthClientSecret = '';
			}
		},
		showAddDialog() {
			this.isEdit = false;
			this.form = {
				email: '',
				provider: '',
				authCode: '',
				isActive: true,
				oauthClientId: '',
				oauthTenantId: '',
				oauthRedirectUri: '',
				oauthClientSecret: ''
			};
			this.dialogVisible = true;
		},
		
		editConfig(config) {
			this.isEdit = true;
			this.form = { ...config };
			this.dialogVisible = true;
		},
		
		async saveConfig() {
			this.$refs.form.validate(async (valid) => {
				if (valid) {
					if (!this.currentUserId) {
						this.$message.error('用户未登录');
						return;
					}
					this.saving = true;
					try {
						if (this.isEdit) {
							await this.$http.put(`/api/email-configs/${this.form.id}`, this.form);
							this.$message.success('更新成功');
						} else {
							const res = await this.$http.post('/api/email-configs', this.form, { params: { userId: this.currentUserId } });
							this.form.id = res.data.id;
							this.$message.success('添加成功');
						}
						this.dialogVisible = false;
						this.loadConfigs();
					} catch (error) {
						console.error('保存失败:', error);
						this.$message.error('保存失败');
					} finally {
						this.saving = false;
					}
				}
			});
		},
		
		async deleteConfig(config) {
			try {
				await this.$confirm('确定要删除这个邮箱配置吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				});
				await this.$http.delete(`/api/email-configs/${config.id}`);
				this.$message.success('删除成功');
				this.loadConfigs();
			} catch (error) {
				if (error !== 'cancel') {
					console.error('删除失败:', error);
					this.$message.error('删除失败');
				}
			}
		},
		
		async testConnection() {
			if (!this.form.email || !this.form.provider) {
				this.$message.warning('请先填写邮箱和提供商');
				return;
			}
			if (this.form.provider !== 'outlook' && !this.form.authCode) {
				this.$message.warning('请先填写授权码');
				return;
			}
			if (this.form.provider === 'outlook' && !this.form.oauthClientId) {
				this.$message.warning('请先填写Client ID');
				return;
			}
			this.testing = true;
			try {
				await this.$http.post('/api/email-configs/test-connection', this.form);
				this.$message.success('连接测试成功！');
			} catch (error) {
				console.error('连接测试失败:', error);
				this.$message.error('连接测试失败，请检查配置信息');
			} finally {
				this.testing = false;
			}
		},
		
		async openOAuth(config) {
			if (!config.id) {
				this.$message.warning('请先保存配置，再进行授权');
				return;
			}
			this.selectedOAuthConfigId = config.id;
			this.authorizing = true;
			try {
				// 后端需要 tenantId 与 clientId 放在请求体
				const res = await this.$http.post('/api/email-configs/outlook/device-code', {
					oauthTenantId: config.oauthTenantId || this.form.oauthTenantId || 'common',
					oauthClientId: config.oauthClientId || this.form.oauthClientId
				});
				this.oauthInfo = res.data;
				this.oauthDialogVisible = true;
			} catch (e) {
				console.error('获取设备码失败:', e);
				this.$message.error('获取设备码失败');
			} finally {
				this.authorizing = false;
			}
		},
		
		async confirmAuthorized() {
			if (!this.selectedOAuthConfigId || !this.oauthInfo || !this.oauthInfo.device_code) {
				this.$message.warning('缺少必要信息');
				return;
			}
			this.authorizing = true;
			try {
				await this.$http.post(`/api/email-configs/${this.selectedOAuthConfigId}/outlook/poll-token`, null, { params: { device_code: this.oauthInfo.device_code } });
				this.$message.success('授权成功');
				this.oauthDialogVisible = false;
				this.selectedOAuthConfigId = null;
				this.loadConfigs();
			} catch (e) {
				console.error('授权失败:', e);
				this.$message.error('授权失败，请稍后重试');
			} finally {
				this.authorizing = false;
			}
		},

		async checkHealth(config) {
			try {
				const res = await this.$http.get(`/api/email-configs/${config.id}/outlook/health`);
				if (res.data && res.data.healthy) {
					this.$message.success('Graph健康检查通过');
				} else {
					this.$message.warning('健康检查未通过');
				}
			} catch (e) {
				console.error('健康检查失败:', e);
				this.$message.error('健康检查失败');
			}
		},

		async refreshToken(config) {
			try {
				await this.$http.post(`/api/email-configs/${config.id}/outlook/refresh-token`);
				this.$message.success('刷新令牌成功');
				this.loadConfigs();
			} catch (e) {
				console.error('刷新令牌失败:', e);
				this.$message.error('刷新令牌失败');
			}
		},
		
		getProviderType(provider) {
			const types = {
				gmail: 'success',
				qq: 'primary',
				netease_163: 'warning',
				outlook: 'info',
				netease_126: 'danger',
				yahoo: 'primary',
				sina: 'warning'
			};
			return types[provider] || 'info';
		},
		
		getProviderName(provider) {
			const names = {
				gmail: 'Gmail',
				qq: 'QQ邮箱',
				netease_163: '网易163',
				outlook: 'Outlook',
				netease_126: '网易126',
				yahoo: 'Yahoo邮箱',
				sina: '新浪邮箱'
			};
			return names[provider] || provider;
		},
		
		formatDate(date) {
			if (!date) return '';
			return new Date(date).toLocaleString();
		}
	}
}
</script>

<style scoped>
.email-configs {
	padding: 20px;
}
</style> 